import { getUrlParams } from 'utils/bom-dom';

export const getTerminalMode = () => {
  const storageTerminalMode = JSON.parse(
    localStorage.getItem('terminalMode') || 'null'
  );
  const { terminalMode: queryTerminalMode } = getUrlParams(['terminalMode']);

  return !!(storageTerminalMode || queryTerminalMode);
};
